import IconButton from '@mui/material/IconButton';
import React, { useContext } from 'react';

import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { Tooltip } from '@mui/material';
import { AccountContext } from '../context/account';


interface ProjectItemProps {
  orderId: number | null
}

export const ProjectItemOrderInfo = ({
  orderId,
}: ProjectItemProps) => {

  const {
    setActiveOrderId,
  } = useContext(AccountContext);

  if (!orderId) {
    return null
  }

  return (
    <Tooltip
      title={'Order info'} 
      placement="bottom" 
      arrow
    >
      <IconButton
        size="small"
        onClick={(e: React.SyntheticEvent) => {
          e.preventDefault()
          setActiveOrderId(orderId)
        }}
      >
        <RequestQuoteIcon sx={{color: '#000'}} />
      </IconButton>
    </Tooltip>
  )
}
